/**
 * Legacy double-orgnr URL aliases use `{duporgnr}` for the trailing org segment
 * so Crossroads can validate it separately from `o/{orgnr}/…`.
 */

/** Crossroads priority so duporgnr aliases are tried before cleaner single-orgnr patterns. */
export const LEGACY_DUPORGNR_ROUTE_PRIORITY = 1;

export function isLegacyDupOrgnrPattern(hash: string | RegExp): boolean {
    return typeof hash === 'string' && /[{:]duporgnr[:}]/.test(hash);
}

export function routePriorityForHash(hash: string | RegExp, basePriority: number): number {
    if (isLegacyDupOrgnrPattern(hash)) {
        return Math.max(basePriority, LEGACY_DUPORGNR_ROUTE_PRIORITY);
    }
    return basePriority;
}

/** Reject legacy matches where the trailing org segment differs from `o/{orgnr}/…`. */
export function applyDupOrgnrLegacyRule(
    route: {rules?: Record<string, unknown>},
    hash: string | RegExp,
): void {
    if (!isLegacyDupOrgnrPattern(hash)) {
        return;
    }
    route.rules = {
        ...route.rules,
        duporgnr: (val: string, _req: string, values: {orgnr?: string}) =>
            val != null && values.orgnr != null && String(val) === String(values.orgnr),
    };
}
